import React, { Component } from 'react'
import { withNamespaces } from "react-i18next";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Icon } from '@iconify/react';
import DataTable from "../../components/Datatable/DataTable";

class MobileAgentComission extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = {};
    }

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        // console.log(this.props.data);
        const { t } = this.props;
        // const image = this.imageImport(require.context("../../assets/images/comission/", false, /\.(png|jpe?g|svg|webp)$/));
        
        return (
            <Auxiliary>
                <div className="content-wrap" >
                    <h5 className="mt-2">{t('commission-illustrate.agent-comm-notice-8')}</h5>
                    {/* <p>The agent’s commission ratio is determined by the two conditions of the total wins and losses of the month and the number of active people, and the commission ratio of the corresponding level will be obtained when they are met at the same time.<br />
                    • Active number: monthly deposit = 100 or effective betting = 500;</p> */}
                    {/* <img src={image["comission-table.jpg"]} alt="hide pwd" /> */}
                    <div className="card-shadow p-3">
                        <DataTable
                            keyField="no"
                            data={this.props.data}
                            columns={this.props.columns}
                            activePage={this.props.activePage}
                            limit={this.props.limit}
                            totalItems={this.props.totalRecords}
                            paginationHandler={(val) => this.datatablesChangeHandler(val, "activePage")}
                            loading={this.props.loading}
                            hideSearchBar={true}
                            hideTotalRecords={true}
                            hidePagination={true}
                            classValue="pd-table"
                            component="delegate-deposit-history"
                        />
                    </div>
                    {/* <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" />{t('commission-illustrate.agent-comm-notice-1')}</p>
                    <h5 className="mt-2">{t('commission-illustrate.agent-comm-notice-5')}</h5>
                    <ul>
                            <li>
                                <p>{t('commission-illustrate.commission')}</p>
                                <p>{t('commission-illustrate.agent-comm-notice-2')}</p>
                                <p>{t('commission-illustrate.agent-comm-notice-4')}</p>
                            </li>
                            <li>
                                <p>{t('commission-illustrate.expenses')}</p>
                                <p>{t('commission-illustrate.agent-comm-notice-3')}</p>
                            </li>
                    </ul>
                    <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" />{t('commission-illustrate.agent-comm-notice-6')}</p> */}
                </div>
            </Auxiliary>
        )
    }
}

export default withNamespaces("translation")(MobileAgentComission);